export const QUERY_KEY_FAVORITES = 'Favorites'
